<template>
  <b-card
    no-body
    class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <h5 class="mb-0">
        Estado
      </h5>
      <b-badge
        class="font-medium-1 px-1"
        :variant="statusVariant(planningOrder.order_status.name)"
      >
        {{ planningOrder.order_status.name }}
      </b-badge>
      <!--      <small class="text-muted w-100">July 22, 2021</small>-->
    </b-card-header>

    <b-card-body>
      <ul class="list-unstyled my-1">
        <li>
          <span class="align-middle text-success">
            <b>{{ planningOrder.design ? 'En diseño' : '' }}</b>
          </span>
          |
          <span
            class="align-middle"
            :class="planningOrder.delivered ? 'text-success' : 'text-warning'"
          >
            <b>{{ planningOrder.delivered ? 'Entregado' : 'No entregado' }}</b>
          </span>
        </li>
        <li class="mt-2">
          <span class="align-middle"><b>Tipo trabajo:</b> {{ planningOrder.order.work_type.name }}</span>
        </li>
        <li class="mt-0">
          <span class="align-middle"><b>Fecha de entrega:</b> {{ planningOrder.order.delivery_date }}</span>
        </li>
      </ul>
      <!--      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
      >
        Upgrade Plan
      </b-button>-->
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BBadge, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
  },
  props: {
    planningOrder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Enviado: 'light-primary',
        Planificación: 'light-info',
        Evaluación: 'light-warning',
        Fabricación: 'light-success',
        Terminado: 'light-secondary',
        Transporte: 'light-dark',
        Entregado: 'light-success',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
  },
}
</script>

<style>

</style>
